'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var base = require('@rixio/atom/build/base');
var atom = require('@rixio/atom');
var wrapped = require('@rixio/wrapped');
var lens$1 = require('@rixio/lens');
var rxjs = require('rxjs');
var operators = require('rxjs/operators');
var react$1 = require('react');
var cache = require('@rixio/cache');
var react = require('@rixio/react');
var mappedSubject = require('@rixio/cache/build/mapped-subject');

function isAtom(o) {
    return o instanceof base.AbstractAtom;
}

function saveToAtom(atom$1) {
    return (observable) => atom.Atom.set(atom$1, observable);
}
function atomize(observable, arg1) {
    const atom$1 = isAtom(arg1) ? arg1 : atom.Atom.create(arg1);
    const saver = observable.pipe(saveToAtom(atom$1));
    return [atom$1.view(), saver];
}
function atomizeWrapped(observable, arg = wrapped.pendingWrapped) {
    return atomize(observable, arg);
}
function forever(atomized) {
    atomized[1].subscribe();
    return atomized[0];
}

class ComputedAtom extends base.AbstractAtom {
    constructor(getter, setter) {
        super(getter());
        this.getter = getter;
        this.setter = setter;
    }
    get() {
        return this.getValue();
    }
    modify(updateFn) {
        const prev = this.getValue();
        const next = updateFn(prev);
        if (lens$1.structEq(prev, next))
            return;
        this.setter(next);
        this.next(next);
    }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function BindableSubjectMixin() {
    return (Base) => {
        var _BindableSubject_subscription, _BindableSubject_subRefs;
        class BindableSubject extends Base {
            constructor() {
                super(...arguments);
                _BindableSubject_subscription.set(this, null);
                _BindableSubject_subRefs.set(this, 0);
            }
            _subscribe(subscriber) {
                if (!__classPrivateFieldGet(this, _BindableSubject_subscription, "f")) {
                    __classPrivateFieldSet(this, _BindableSubject_subscription, this._bounded.subscribe((v) => this._onBoundedValue(v)), "f");
                }
                __classPrivateFieldSet(this, _BindableSubject_subRefs, __classPrivateFieldGet(this, _BindableSubject_subRefs, "f") + 1, "f");
                const sub = new rxjs.Subscription(() => {
                    __classPrivateFieldSet(this, _BindableSubject_subRefs, __classPrivateFieldGet(this, _BindableSubject_subRefs, "f") - 1, "f");
                    if (__classPrivateFieldGet(this, _BindableSubject_subRefs, "f") <= 0 && __classPrivateFieldGet(this, _BindableSubject_subscription, "f")) {
                        __classPrivateFieldGet(this, _BindableSubject_subscription, "f").unsubscribe();
                        __classPrivateFieldSet(this, _BindableSubject_subscription, null, "f");
                    }
                });
                sub.add(super._subscribe(subscriber));
                return sub;
            }
            unsubscribe() {
                if (__classPrivateFieldGet(this, _BindableSubject_subscription, "f")) {
                    __classPrivateFieldGet(this, _BindableSubject_subscription, "f").unsubscribe();
                    __classPrivateFieldSet(this, _BindableSubject_subscription, null, "f");
                }
                __classPrivateFieldSet(this, _BindableSubject_subRefs, 0, "f");
                super.unsubscribe();
            }
        }
        _BindableSubject_subscription = new WeakMap(), _BindableSubject_subRefs = new WeakMap();
        return BindableSubject;
    };
}

class MapCache {
    constructor(factory) {
        this.factory = factory;
        this.map = new Map();
    }
    get(key, onCreate) {
        let value = this.map.get(key);
        if (value === undefined) {
            value = this.factory(key);
            this.map.set(key, value);
            onCreate === null || onCreate === void 0 ? void 0 : onCreate(value);
        }
        return value;
    }
}

const lens = lens$1.Lens.create((wrapped) => (wrapped.status === "fulfilled" ? wrapped.value : undefined), (value) => wrapped.createFulfilledWrapped(value));
function wrappedFulfilledLens() {
    return lens;
}

class WrappedCompletedError extends Error {
    constructor() {
        super("Wrapped Observable completed while pending");
    }
}
function wrappedToPromise(observable) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield new Promise((resolve, reject) => {
            const subscriber = new rxjs.Subscriber({
                next: (x) => {
                    resolve(x);
                    subscriber.unsubscribe();
                },
                error: (error) => {
                    reject(error);
                    subscriber.unsubscribe();
                },
                complete: () => {
                    reject(new rxjs.EmptyError());
                    subscriber.unsubscribe();
                },
            });
            observable.pipe(operators.filter((x) => x.status !== "pending")).subscribe(subscriber);
        });
        switch (result.status) {
            case "rejected":
                throw result.error;
            case "fulfilled":
                return result.value;
            default:
                throw new Error("Never happens");
        }
    });
}

function wrappedThen(fulfilledCallback, rejectedCallback) {
    return (observable) => {
        return observable.pipe(operators.mergeMap((value) => {
            switch (value.status) {
                case "pending":
                    return rxjs.of(wrapped.pendingWrapped);
                case "rejected": {
                    if (typeof rejectedCallback === "function") {
                        return wrapCallback(rejectedCallback, [value.error]);
                    }
                    return rxjs.of(value);
                }
                case "fulfilled":
                    return wrapCallback(fulfilledCallback, [value.value]);
            }
            return rxjs.of(wrapped.pendingWrapped);
            function wrapCallback(cb, args, reload) {
                try {
                    const result = cb(...args);
                    if (typeof result === "object" && result && "then" in result && typeof result.then === "function") {
                        return wrapped.fromPromise(result);
                    }
                    else {
                        return rxjs.of(wrapped.createFulfilledWrapped(result));
                    }
                }
                catch (error) {
                    return rxjs.of(wrapped.createRejectedWrapped(error, reload));
                }
            }
        }));
    };
}

var _Cache_promise;
class Cache extends cache.CacheImpl {
    constructor(loader, atom$1 = atom.Atom.create(cache.idleCache)) {
        super(atom$1, loader);
        _Cache_promise.set(this, void 0);
    }
    get fulfilledValue() {
        return this.atom.view();
    }
    get(force = false) {
        var _a;
        if (force) {
            this.clear();
        }
        __classPrivateFieldSet(this, _Cache_promise, (_a = __classPrivateFieldGet(this, _Cache_promise, "f")) !== null && _a !== void 0 ? _a : wrappedToPromise(this), "f");
        return __classPrivateFieldGet(this, _Cache_promise, "f");
    }
    set(value) {
        this.atom.set(cache.createFulfilledCache(value));
        __classPrivateFieldSet(this, _Cache_promise, undefined, "f");
    }
    _onValue(x) {
        if (x.status === "idle") {
            __classPrivateFieldSet(this, _Cache_promise, undefined, "f");
        }
        return super._onValue(x);
    }
}
_Cache_promise = new WeakMap();
function immediateCache(cache) {
    cache.subscribe();
    return cache;
}

function RxCache({ cache, idle, pending, rejected, children }) {
    const state = react.useAtom(cache.atom);
    const reload = react$1.useCallback(() => cache.get(true), [cache]);
    switch (state.status) {
        case "idle":
            if (idle === undefined) {
                throw new Error("No idle component found");
            }
            if (typeof idle === "function") {
                return idle(reload);
            }
            return idle;
        case "pending":
            if (pending === undefined) {
                throw new Error("No pending component found");
            }
            return pending;
        case "rejected":
            if (rejected === undefined) {
                throw new Error("No rejected component found");
            }
            if (typeof rejected === "function") {
                return rejected(state.error, reload);
            }
            return rejected;
        case "fulfilled":
            if (typeof children === "function") {
                return children(state.value);
            }
            return children !== null && children !== void 0 ? children : state.value;
    }
    return null;
}

function useAtomCreate(initialValueOrAtom, atomMaybe) {
    return react$1.useState(() => {
        const atom$1 = isAtom(initialValueOrAtom) ? initialValueOrAtom : atomMaybe;
        const initialValue = isAtom(initialValueOrAtom) ? undefined : initialValueOrAtom;
        if (atom$1)
            return atom$1;
        if (initialValue === undefined)
            return atom.Atom.create(undefined);
        if (typeof initialValue === "function")
            return atom.Atom.create(initialValue());
        return atom.Atom.create(initialValue);
    })[0];
}
function useCacheCreate(promiseOrLoader, atomOrDeps, maybeAtom) {
    const loader = typeof promiseOrLoader === "function" ? promiseOrLoader : () => promiseOrLoader;
    const deps = typeof promiseOrLoader === "function" ? atomOrDeps : [promiseOrLoader];
    const atom = typeof promiseOrLoader === "function" ? maybeAtom : atomOrDeps;
    return react$1.useMemo(() => {
        return new Cache(loader, atom);
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}

function useRxPipe(observable, pipeCreator, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const pipe = react$1.useMemo(() => pipeCreator(), deps);
    return react$1.useMemo(() => pipe(observable), [observable, pipe]);
}

function useRxEffect(observable, effect, deps = [], needImmediate = false) {
    const piped = useRxPipe(observable, () => rxjs.pipe((o) => {
        if (!needImmediate)
            return o;
        if (o instanceof rxjs.BehaviorSubject)
            return o;
        return o.pipe(operators.startWith(undefined));
    }, operators.tap(effect)), [needImmediate, ...deps]);
    react$1.useEffect(() => {
        const sub = piped.subscribe();
        return () => sub.unsubscribe();
    }, [piped]);
}

function useReactAtomizedInitialArg(arg) {
    return react$1.useState(() => {
        if (isAtom(arg))
            return arg;
        if (typeof arg === "function")
            return atom.Atom.create(arg());
        return atom.Atom.create(arg);
    })[0];
}
function useAtomize(observable, arg) {
    const store = useReactAtomizedInitialArg(arg);
    const [atom, saver] = react$1.useMemo(() => atomize(observable, store), [observable, store]);
    useRxEffect(saver);
    return atom;
}
function useAtomizeWrapped(observable, arg = wrapped.pendingWrapped) {
    return useAtomize(observable, arg);
}

function useRxReducer(reducer, arg) {
    const store = useReactAtomizedInitialArg(arg);
    const dispatch = react$1.useCallback((action) => {
        store.modify((state) => reducer(state, action));
    }, [reducer, store]);
    return [store.view(), dispatch];
}

function useAtomMap(atom, getter, arg2, arg3) {
    const setter = typeof arg2 === "function" ? arg2 : undefined;
    const deps = typeof arg2 === "function" ? arg3 : arg2;
    return react$1.useMemo(() => {
        if (typeof setter === "function" && atom instanceof base.AbstractAtom) {
            return atom.lens(lens$1.Lens.create(getter, setter));
        }
        else {
            return atom.view(getter);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [atom, ...deps]);
}

function useRxCombine(array) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react$1.useMemo(() => rxjs.combineLatest(array), array);
}
function useRxCombineWrapped(array) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return react$1.useMemo(() => wrapped.combineLatest(array), array);
}

function useWrappedThen(observable, fulfilledCallback, arg3, arg4) {
    var _a;
    const rejectedCallback = typeof arg3 === "function" ? arg3 : undefined;
    const deps = (_a = (typeof arg3 === "function" ? arg4 : arg3)) !== null && _a !== void 0 ? _a : [];
    return useRxPipe(observable, () => rxjs.pipe(wrappedThen(fulfilledCallback, rejectedCallback)), deps);
}

const async = "___async___";
const symbol = Symbol.for(async);

const idle = { status: "idle" };
function createStarting(value) {
    return { status: "starting", value };
}
const pending = { status: "pending" };
function createRejected(error) {
    return { status: "rejected", error };
}
function createFulfilled(value) {
    return { status: "fulfilled", value };
}
const initAsync = {
    [async]: symbol,
    current: pending,
    getter: idle,
    setter: idle,
};
function createAsync(current, getter, setter) {
    return { [async]: symbol, current, getter, setter };
}
function createAsyncWrapped(current, getter, setter) {
    return { current, getter, setter };
}
const pendingAsyncWrapped = createAsyncWrapped(wrapped.pendingWrapped, wrapped.pendingWrapped, wrapped.pendingWrapped);
const asyncStateValue = (() => {
    const creator = () => lens$1.Lens.create((state) => {
        return state.current.status === "fulfilled" ? state.current.value : undefined;
    }, (value, state) => {
        return value !== undefined ? createAsync(createFulfilled(value), state.getter, state.setter) : state;
    });
    const lens = creator();
    return () => lens;
})();
function wrappedToAsyncValueState(wrapped) {
    switch (wrapped.status) {
        case "pending":
            return pending;
        case "rejected":
            return createRejected(wrapped.error);
        case "fulfilled":
            return createFulfilled(wrapped.value);
    }
}
function wrappedToGetterState(wrapped, state) {
    const value = wrappedToAsyncValueState(wrapped);
    if (wrapped.status === "fulfilled") {
        return createAsync(value, value, state.setter);
    }
    if (state.current.status === "fulfilled") {
        return createAsync(state.current, value, state.setter);
    }
    else {
        return createAsync(value, value, state.setter);
    }
}
function asyncValueStateToWrapped(state) {
    switch (state.status) {
        case "pending":
            return wrapped.pendingWrapped;
        case "rejected":
            return wrapped.createRejectedWrapped(state.error);
        case "fulfilled":
            return wrapped.createFulfilledWrapped(state.value);
    }
}
function asyncLoaderStateToWrapped(state) {
    switch (state.status) {
        case "idle":
        case "starting":
            return wrapped.pendingWrapped;
        default:
            return asyncValueStateToWrapped(state);
    }
}
function asyncStateToAsyncWrapped(state) {
    return createAsyncWrapped(asyncValueStateToWrapped(state.current), asyncLoaderStateToWrapped(state.getter), asyncLoaderStateToWrapped(state.setter));
}

var _Async_getter, _Async_setter, _Async_getterPromise, _Async_setterPromise;
class Async extends mappedSubject.MappedSubject {
    constructor(getter, setter, state = atom.Atom.create(initAsync)) {
        super(state, pendingAsyncWrapped);
        this.state = state;
        _Async_getter.set(this, void 0);
        _Async_setter.set(this, void 0);
        _Async_getterPromise.set(this, void 0);
        _Async_setterPromise.set(this, void 0);
        __classPrivateFieldSet(this, _Async_getter, getter, "f");
        __classPrivateFieldSet(this, _Async_setter, setter, "f");
    }
    get currentState() {
        return this.pipe(operators.map((wrapped) => wrapped.current));
    }
    get getterState() {
        return this.pipe(operators.map((wrapped) => wrapped.getter));
    }
    get setterState() {
        return this.pipe(operators.map((wrapped) => wrapped.setter));
    }
    get currentValue() {
        return this.state.lens(asyncStateValue());
    }
    get(force = false) {
        const state = this.state.get();
        if (force || (state.current.status === "pending" && state.getter.status === "idle")) {
            this.state.lens("getter").set(createStarting(undefined));
        }
        else if (state.current.status === "fulfilled") {
            return Promise.resolve(state.current.value);
        }
        if (!__classPrivateFieldGet(this, _Async_getterPromise, "f")) {
            const sub = this.subscribe();
            __classPrivateFieldSet(this, _Async_getterPromise, wrappedToPromise(this.getterState), "f");
            __classPrivateFieldGet(this, _Async_getterPromise, "f").finally(() => sub.unsubscribe());
        }
        return __classPrivateFieldGet(this, _Async_getterPromise, "f");
    }
    set(value) {
        this.state.lens("current").set(createFulfilled(value));
        this.state.lens("setter").set(createStarting(value));
        if (!__classPrivateFieldGet(this, _Async_setterPromise, "f")) {
            const sub = this.subscribe();
            __classPrivateFieldSet(this, _Async_setterPromise, wrappedToPromise(this.setterState), "f");
            __classPrivateFieldGet(this, _Async_setterPromise, "f").finally(() => sub.unsubscribe());
        }
        return __classPrivateFieldGet(this, _Async_setterPromise, "f");
    }
    modify(operator) {
        return this.set(operator(this.currentValue.get()));
    }
    clearGetter() {
        this.state.lens("getter").set(idle);
    }
    clearSetter() {
        this.state.lens("setter").set(idle);
    }
    clear() {
        this.state.set(initAsync);
    }
    _onValue(x) {
        if (x.getter.status === "starting") {
            const observable = wrapped.fromPromise(__classPrivateFieldGet(this, _Async_getter, "f").call(this)).pipe(operators.map((wrapped) => wrappedToGetterState(wrapped, this.state.get())));
            atom.Atom.set(this.state, observable).toPromise();
        }
        if (x.setter.status === "starting") {
            const current = this.currentValue;
            const wrapped$1 = wrapped.fromPromise(__classPrivateFieldGet(this, _Async_setter, "f").call(this, x.setter.value, current.get()));
            current.set(x.setter.value);
            const observable = wrapped$1.pipe(operators.map((wrapped) => wrappedToAsyncValueState(wrapped)));
            atom.Atom.set(this.state.lens("setter"), observable).toPromise();
        }
        const next = asyncStateToAsyncWrapped(x);
        if (next !== this.getValue()) {
            this.next(next);
        }
    }
}
_Async_getter = new WeakMap(), _Async_setter = new WeakMap(), _Async_getterPromise = new WeakMap(), _Async_setterPromise = new WeakMap();

function RxAsync({ atom, pending, rejected, children }) {
    const state = react.useAtom(atom.state);
    const reload = react$1.useCallback(() => atom.get(true), [atom]);
    switch (state.current.status) {
        case "pending":
            if (pending === undefined) {
                throw new Error("No pending component found");
            }
            return pending;
        case "rejected":
            if (rejected === undefined) {
                throw new Error("No rejected component found");
            }
            if (typeof rejected === "function") {
                return rejected(state.current.error, reload);
            }
            return rejected;
        case "fulfilled":
            if (typeof children === "function") {
                return children(state.current.value, state);
            }
            return children !== null && children !== void 0 ? children : state.current.value;
    }
    return null;
}

exports.Async = Async;
exports.BindableSubjectMixin = BindableSubjectMixin;
exports.Cache = Cache;
exports.ComputedAtom = ComputedAtom;
exports.MapCache = MapCache;
exports.RxAsync = RxAsync;
exports.RxCache = RxCache;
exports.WrappedCompletedError = WrappedCompletedError;
exports.asyncLoaderStateToWrapped = asyncLoaderStateToWrapped;
exports.asyncStateToAsyncWrapped = asyncStateToAsyncWrapped;
exports.asyncStateValue = asyncStateValue;
exports.asyncValueStateToWrapped = asyncValueStateToWrapped;
exports.atomize = atomize;
exports.atomizeWrapped = atomizeWrapped;
exports.createAsync = createAsync;
exports.createAsyncWrapped = createAsyncWrapped;
exports.createFulfilled = createFulfilled;
exports.createRejected = createRejected;
exports.createStarting = createStarting;
exports.forever = forever;
exports.idle = idle;
exports.immediateCache = immediateCache;
exports.initAsync = initAsync;
exports.isAtom = isAtom;
exports.pending = pending;
exports.pendingAsyncWrapped = pendingAsyncWrapped;
exports.saveToAtom = saveToAtom;
exports.useAtomCreate = useAtomCreate;
exports.useAtomMap = useAtomMap;
exports.useAtomize = useAtomize;
exports.useAtomizeWrapped = useAtomizeWrapped;
exports.useCacheCreate = useCacheCreate;
exports.useReactAtomizedInitialArg = useReactAtomizedInitialArg;
exports.useRxCombine = useRxCombine;
exports.useRxCombineWrapped = useRxCombineWrapped;
exports.useRxEffect = useRxEffect;
exports.useRxPipe = useRxPipe;
exports.useRxReducer = useRxReducer;
exports.useWrappedThen = useWrappedThen;
exports.wrappedFulfilledLens = wrappedFulfilledLens;
exports.wrappedThen = wrappedThen;
exports.wrappedToAsyncValueState = wrappedToAsyncValueState;
exports.wrappedToGetterState = wrappedToGetterState;
exports.wrappedToPromise = wrappedToPromise;
